import { useFetch } from '@reveni-io/reveni-ui'

import returnsServices from '@/returns/services/services'

const useMarkAlertAsResolved = ({ returnId, fetchData, fetchTimeline, setToastInfo }) => {
  const { fetchData: markAlertAsResolved, loading: markingAlertAsResolved } = useFetch(
    returnsServices.markAlertAsResolved,
    { doInitialRequest: false }
  )

  const handleMarkAlertAsResolved = async alert => {
    try {
      await markAlertAsResolved({ returnId, alertId: alert.id })
      fetchData()
      fetchTimeline()
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return {
    handleMarkAlertAsResolved,
    markingAlertAsResolved,
  }
}

export default useMarkAlertAsResolved
